const colors = {
  primary: {
    DEFAULT: '#4EA5D9',
    100: '#ebf5fa',
    200: '#d7ebf6',
    300: '#c4e1f2',
    400: '#b0d7ee',
    500: '#9ccde9',
    600: '#89c3e5',
    700: '#75b9e1',
    800: '#61afdd',
  },
  secondary: {
    DEFAULT: '#D4DF9E',
    100: '#fafbf4',
    200: '#f5f7e9',
    300: '#f0f4de',
    400: '#ebf0d3',
    500: '#e7edc9',
    600: '#e2e9be',
    700: '#dde6b3',
    800: '#d8e2a8',
  },
  gray: {
    DEFAULT: '#2A3D45',
    100: '#e7e9ea',
    200: '#cfd3d5',
    300: '#b8bec1',
    400: '#a0a8ac',
    500: '#889397',
    600: '#717d83',
    700: '#59686e',
    800: '#415259',
  },
}

module.exports = colors
